import { getFirestore, doc, deleteDoc } from 'firebase/firestore'
import { FitbitUserAPI } from '@/helpers/fitbit'
import { UserServiceAPI } from '@/helpers/service'
import { useUserStore } from '@/stores/user'

export default class Target {
  constructor(
    duration,
    bedTime,
    wakeTime,
    id,
    active,
    ) {
    this.id = id
    this.duration = duration
    this.bedTime = bedTime
    this.wakeTime = wakeTime
    this.active = active
    this._ref = this.ref
  }

  get ref() {
    if (!this._ref) {
      this._ref = doc(getFirestore(), 'targets', this.id)
    }
    return this._ref
  }

  static async create(duration, bedTime, wakeTime) {
    const apiService = new UserServiceAPI()
    const result = await apiService.postTarget(duration, bedTime, wakeTime)

    return new Target(
      result.duration,
      result.bedTime,
      result.wakeTime,
      result.id,
      result.active,
    )
  }

  static async load() {
    const apiService = new UserServiceAPI()
    const result = await apiService.getTarget()
    if (!result) {
      return null
    }

    return new Target(
      result.duration,
      result.bedTime,
      result.wakeTime,
      result.id,
      result.active,
    )
  }

  async save() {
    // TODO: Sync targets from database to Fitbit?
    const apiService = new UserServiceAPI()
    const result = await apiService.putTarget(
      this.id,
      this.duration,
      this.bedTime,
      this.wakeTime
    )

    return new Target(
      result.duration,
      result.bedTime,
      result.wakeTime,
      result.id,
      result.active,
    )
  }

  async delete() {
    await deleteDoc(this.ref)
  }

  static async syncFitbit() {
    // Only sync sleep target from Fitbit if the user doesn't have one.
    const userStore = useUserStore()
    if (userStore.user?.target) {
      return null
    }

    const api = new FitbitUserAPI()
    const data = await api.getSleepTarget()
    // Missing or no sleep targets in Fitbit found.
    if (!data || !data.goal || !data.goal.minDuration || !data.goal.bedtime || !data.goal.wakeupTime) {
      return null
    }

    return Target.create(data.goal.minDuration, data.goal.bedtime, data.goal.wakeupTime)
  }
}